import React, {
  useContext,
  // useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react'
import { Redirect, useLocation } from 'react-router-dom'
// import AppContext from "app/appContext";
import useAuth from 'app/hooks/useAuth'
import { useStore } from 'app/store'
import { observer } from 'mobx-react'
import { MatxLoading } from 'app/components'
import AppContext from 'app/contexts/AppContext'
import { usePermissionGate } from 'app/containers/PermissionsGate/PermissionsGate'

const getUserRoleAuthStatus = (pathname, roles, routes) => {
  const matched = routes.find((r) => r.path === pathname);

  const authenticated =
    matched && matched.auth && matched.auth.length
      ? matched.auth.some((role) => roles.includes(role))
      : true;
  // console.log(matched, user);
  return authenticated;
};

const AuthGuard = ({ children }) => {
  const {
    isAuthenticated,
    // user
  } = useAuth()
  const { isScopesGranted } = usePermissionGate()
  const [previouseRoute, setPreviousRoute] = useState(null)
  const { pathname } = useLocation()
  const { dashboard, enterpriseStore } = useStore()
  const [isLoading, setIsLoading] = useState(true)

  const { routes } = useContext(AppContext);
  const routeObject = routes.find((r) => r.path === pathname);
  const isUserRoleAuthenticated = getUserRoleAuthStatus(pathname, dashboard.userData?.permissions ?? [], routes);

  // let authenticated = isAuthenticated && isUserRoleAuthenticated;

  // IF YOU NEED ROLE BASED AUTHENTICATION,
  // UNCOMMENT ABOVE TWO LINES, getUserRoleAuthStatus METHOD AND user VARIABLE
  // AND COMMENT OUT BELOW LINE
  let authenticated = isAuthenticated

  useLayoutEffect(() => {
    if (authenticated) {
      dashboard.getUserData().then(() => {
        enterpriseStore.getBalance()
      }).finally(() => setIsLoading(false))
    }
    return () => setIsLoading(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated])

  useEffect(() => {
    if (previouseRoute !== null) setPreviousRoute(pathname)
  }, [pathname, previouseRoute])

  if (!authenticated) {
    return (
      <Redirect
        to={{
          pathname: '/signin',
          state: { redirectUrl: previouseRoute },
        }}
      />
    )
  }
  if (!dashboard.userData) {
    if (isLoading) {
      return <MatxLoading />
    } else {
      return <div>Failed to load user data.</div>
    }
  }
  if(!isUserRoleAuthenticated || !isScopesGranted(routeObject?.scopes)) {
    return <div>Unauthorized</div>
  }

  return <>{children}</>
}

export default observer(AuthGuard)
